import React from "react";
import { Card, Typography, Divider } from "antd";

const { Title, Paragraph } = Typography;

export default function TermsAndConditions() {
  return (
    <div className="terms-container">
      <Card className="terms-card" bordered>
        <Typography className="terms-text">

          <Title level={2} className="terms-title">
            Terms & Conditions
          </Title>

          <Paragraph className="updated-text">
            <strong>Last Updated: 18 December 2025</strong>
          </Paragraph>

          <Paragraph>
            Welcome to <strong>Fusion Hub</strong>. Fusion Hub is a gym and fitness
            training–related platform that provides workout programs, trainer guidance,
            fitness resources, and related services. By accessing or using our website,
            mobile application, or services, you agree to comply with the following
            Terms & Conditions.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            1. Acceptance of Terms
          </Title>
          <Paragraph>
            By accessing or using Fusion Hub, you acknowledge that you have read,
            understood, and agreed to these Terms & Conditions. If you do not agree,
            you must discontinue use of our platform and services immediately.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            2. User Responsibilities
          </Title>
          <Paragraph>
            As a user of Fusion Hub, you agree to:
            <br />• Provide accurate and complete information during registration.
            <br />• Maintain the confidentiality of your login credentials.
            <br />• Use the platform only for lawful and fitness-related purposes.
            <br />• Follow all gym rules, safety guidelines, and trainer instructions.
            <br />• Respect other users, trainers, and staff members.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            3. Health & Safety Disclaimer
          </Title>
          <Paragraph>
            You confirm that you are medically fit to participate in physical training
            and exercise programs. Fusion Hub is not responsible for injuries, health
            issues, or complications resulting from improper exercise techniques,
            misuse of equipment, failure to follow instructions, or ignoring medical
            advice. Always consult a physician before starting any fitness program.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            4. Payments, Memberships & Subscriptions
          </Title>
          <Paragraph>
            • All membership fees, training plans, and subscriptions must be paid on time.
            <br />• Payments are processed through secure third-party payment gateways.
            Fusion Hub does not store card or payment details.
            <br />• Fees are non-refundable unless explicitly stated in our Refund Policy.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            5. Cancellations & Account Termination
          </Title>
          <Paragraph>
            Fusion Hub reserves the right to suspend or terminate user accounts if
            these Terms are violated or if the platform is misused. Users may cancel
            their membership according to the applicable cancellation policy.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            6. Intellectual Property
          </Title>
          <Paragraph>
            All content on Fusion Hub, including workout plans, training materials,
            videos, images, logos, designs, and branding, is the intellectual property
            of <strong>Fusion Hub</strong>. Unauthorized copying, distribution, or use
            of this content is strictly prohibited.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            7. Limitation of Liability
          </Title>
          <Paragraph>
            Fusion Hub shall not be held liable for any injuries, losses, damages,
            data loss, or service interruptions arising from the use or inability
            to use our platform, third-party services, or internet connectivity issues.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            8. Changes to Terms & Conditions
          </Title>
          <Paragraph>
            Fusion Hub reserves the right to update or modify these Terms & Conditions
            at any time. Continued use of the platform after changes are made indicates
            acceptance of the updated terms.
          </Paragraph>

          <Divider />

          <Paragraph>
            For any questions or concerns regarding these Terms & Conditions, please
            contact us at: <strong>support@fusionhub.com</strong>
          </Paragraph>

        </Typography>
      </Card>
    </div>
  );
}
